module.exports = __webpack_public_path__ + "img/Frame 24.6db6820e.png";